import './DesktopViewport.scss';

import React from 'react';
import Sidebar from '../sidebar/Sidebar';
import MapView from '../map/mapview/MapView';
import {useTrip} from '../context/TripContext';

export interface DesktopViewportProps {
  googleMapsApiKey: string;
}

const DesktopViewport: React.FC<DesktopViewportProps> = ({ googleMapsApiKey }) => {
  const trip = useTrip();
  return (
      <main className='fr-desktop'>
        <Sidebar trip={trip}/>
        <MapView googleMapsApiKey={googleMapsApiKey}/>
      </main>
  );
}

export default DesktopViewport;
